export const SETTINGS = {
    LOAD: 'SETTINGS/LOAD',
    RESET: 'SETTINGS/RESET'
};
